<template>
    <button @click="reset()" type="button" class="btn btn-sm btn-success btn-block">
        <li class="fa fa-recycle"></li> ENVIAR TIMEZONE
    </button>
</template>
<script>
    import {Comandos} from '../../class';
    import {Bus} from '../../class/bus';
    export default {
        props: {
            id_rastreador: {
                "default": null
            },
            timezone: {
                default: 0
            }
        },
        methods: {
            async reset () {
                await Comandos.setTimezone(this.id_rastreador, this.timezone);
                Bus.$emit('comandos');
            }
        }
    }
</script>
